import { Button } from 'ui/button';
import { BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button/constants';
import { ModalFooter, ModalBody, ModalHeader, Modal, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';

export const UNSAVED_CHANGES_MODAL_TEST_ID = 'unsaved-changes-modal';
export const UNSAVED_CHANGES_MODAL_SAVE_BUTTON_TEST_ID = 'unsaved-changes-modal-save-button';
export const UNSAVED_CHANGES_MODAL_DISCARD_BUTTON_TEST_ID = 'unsaved-changes-modal-discard-button';

type Props = {
  onClose: () => void;
  onDiscard?: () => void;
  onSave?: () => void;
};

export const UnsavedChangesModal = ({ onClose, onDiscard, onSave }: Props) => {
  return (
    <Modal
      id={UNSAVED_CHANGES_MODAL_TEST_ID}
      isModalOpen={true}
      onClose={onClose}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
    >
      <ModalHeader autoFocus={false}>Unsaved changes</ModalHeader>
      <ModalBody>This role has been edited. Do you want to save your changes?</ModalBody>
      <ModalFooter onClose={onClose} cancelLabel="Cancel">
        <Button
          data-test={UNSAVED_CHANGES_MODAL_DISCARD_BUTTON_TEST_ID}
          size={BUTTON_SIZES.LARGE}
          variant={BUTTON_VARIANTS.SECONDARY}
          onClick={onDiscard}
        >
          Leave without saving
        </Button>
        <Button
          data-test={UNSAVED_CHANGES_MODAL_SAVE_BUTTON_TEST_ID}
          size={BUTTON_SIZES.LARGE}
          onClick={onSave}
        >
          Save and exit
        </Button>
      </ModalFooter>
    </Modal>
  );
};
